
// Extend scope with SWTY functions
import './literal/scope.js';
// Register <template is="literal-html">
import 'literal/literal-html/module.js';
// Register <details-toggle>
import 'details-toggle/module.js';
// Range input element
import 'form-elements/range-input/module.js';
// Register and customise <slide-show>
import './elements/slide-show.js';
// Enhance dialogs
import 'bolt/elements/dialog.js';
// Interactive attributes
// data-locateable is included on a page-by-page basis as it is potentially expensive
import 'bolt/attributes/data-popable.js';
import 'bolt/attributes/data-switchable.js';
import 'bolt/attributes/data-validateable.js';
import './attributes/data-submittable-swty.js';
import './attributes/data-highlightable.js';
import './attributes/type=file.js';
import 'bolt/classes/scroll.js';
import './classes/loading.js';
import './classes/type-here.js';
import './classes/newsletter.js';


// Font page
import './classes/banner.js';

// checkout
import './classes/copy-address.js';

// support
import '../components/search-field/suggest.js';


// Set CSRF Token
import cookies    from '../dom/scripts/cookies.js';
import { config } from 'dom/request.js';
const csrf = cookies.get('csrftoken');
config.headers = function(object) {
    object["X-CSRFToken"] = csrf;
    return object;
};

// Display messages from server on page load
import { showMessage } from '../messages/module.js';
if (window.config.messages) {
    window.config.messages.map((message) => showMessage(message));
}




/* 2018 BUILD
  import '/static/bolt/classes/device.js';
  import '/static/components/newsletter/view.js';
  import '/static/components/site/footer.js';
  import '/static/components/user/views.js';
  import '/static/components/user/override-redirections.js';
*/
